module.exports = __webpack_public_path__ + "static/media/car-past.b1131592.svg";